const studentInitialState = {
    //Browse Tutor
    loadingBrowseTutorDataListApi: false,
    BrowseTutorDataListApiData: [],
    BrowseTutorDataListApiError: '',


    loadingBrowseTutorDetailListApi: false,
    BrowseTutorDetailListApiData: [],
    BrowseTutorDetailListApiError: '',

    loadingGroupCourseListApi: false,
    GroupCourseListApiData: [],
    GroupCourseListApiError: '',

    loadingGroupCourseBatchListApi: false,
    GroupCourseBatchListApiData: [],
    GroupCourseBatchListApiError: '',

    loadingGroupCourseBatchSessionListApi: false,
    GroupCourseBatchSessionListApiData: [],
    GroupCourseBatchSessionListApiError: '',


    loadingCategoryOnTutorListApi: false,
    CategoryOnTutorListApiData: [],
    CategoryOnTutorListApiError: '',

    loadingSubCategoryOnTutorListApi: false,
    SubCategoryOnTutorListApiData: [],
    SubCategoryOnTutorListApiError: '',


    loadingChildCategoryOnTutorListApi: false,
    ChildCategoryOnTutorListApiData: [],
    ChildCategoryOnTutorListApiError: '',

    loadingStudentTutorRequestListApi: false,
    StudentTutorRequestListApiData: [],
    StudentTutorRequestListApiError: '',

    loadingStudentApprovedTutorListApi: false,
    StudentApprovedTutorListApiData: [],
    StudentApprovedTutorListApiError: '',


    loadingStudentTutorRequestDetailsApi: false,
    StudentTutorRequestDetailsApiData: [],
    StudentTutorRequestDetailsApiError: '',

    loadingStudentApprovedTutorDetailsApi: false,
    StudentApprovedTutorDetailsApiData: [],
    StudentApprovedTutorDetailsApiError: '',


    loadingMyBookingsListApi: false,
    MyBookingsListApiData: [],
    MyBookingsListApiError: '',

    loadingStudentStudyMaterialVideoListApi: false,
    StudentStudyMaterialVideoListApiData: [],
    StudentStudyMaterialVideoListApiError: '',

    loadingStudentStudyMaterialImageListApi: false,
    StudentStudyMaterialImageListApiData: [],
    StudentStudyMaterialImageListApiError: '',

    loadingStudentStudyMaterialPdfListApi: false,
    StudentStudyMaterialPdfListApiData: [],
    StudentStudyMaterialPdfListApiError: '',

    loadingStudentStudyMaterialDocListApi: false,
    StudentStudyMaterialDocListApiData: [],
    StudentStudyMaterialDocListApiError: '',

    loadingStudentStudyMaterialPptListApi: false,
    StudentStudyMaterialPptListApiData: [],
    StudentStudyMaterialPptListApiError: '',

    loadingStudentQueriesListApi: false,
    StudentQueriesListApiData: [],
    StudentQueriesListApiError: '',

    loadingStudentQueriesDetailApi: false,
    StudentQueriesDetailApiData: [],
    StudentQueriesDetailApiError: '',

    loadingStudentMyTutorOneToOneListApi: false,
    StudentMyTutorOneToOneListApiData: [],
    StudentMyTutorOneToOneListApiError: '',

    loadingStudentMyTutorGroupListApi: false,
    StudentMyTutorGroupListApiData: [],
    StudentMyTutorGroupListApiError: '',

    loadingStudentBookedTutorDetailApi: false,
    StudentBookedTutorDetailApiData: [],
    StudentBookedTutorDetailApiError: '',

    loadingStudentOnlineLectureOneToOneMonthlyApi: false,
    StudentOnlineLectureOneToOneMonthlyApiData: [],
    StudentOnlineLectureOneToOneMonthlyApiError: '',

    loadingStudentOnlineLectureOneToOneTodayApi: false,
    StudentOnlineLectureOneToOneTodayApiData: [],
    StudentOnlineLectureOneToOneTodayApiError: '',

    loadingStudentOnlineLectureGroupMonthlyApi: false,
    StudentOnlineLectureGroupMonthlyApiData: [],
    StudentOnlineLectureGroupMonthlyApiError: '',

    loadingStudentOnlineLectureGroupTodayApi: false,
    StudentOnlineLectureGroupTodayApiData: [],
    StudentOnlineLectureGroupTodayApiError: '',

    loadingStudentCompletedAssListApi: false,
    StudentCompletedAssListApiData: [],
    StudentCompletedAssListApiError: '',

    loadingStudentUpcomingAssListApi: false,
    StudentUpcomingAssListApiData: [],
    StudentUpcomingAssListApiError: '',


    loadingStudenNotificationListApi: false,
    StudenNotificationListApiData: [],
    StudenNotificationListApiError: '',

    loadingStudentSmallNotificationListApi: false,
    StudentSmallNotificationListApiData: [],
    StudentSmallNotificationListApiError: '',


    loadingStudentBookedCourseListApi: false,
    StudentBookedCourseListApiData: [],
    StudentBookedCourseListApiError: '',



}

const StudentReducer = (state = studentInitialState, action) => {
    switch (action.type) {


        case 'FETCH_BROWSE_TUTOR_DATA_REQUEST':
            return {
                ...state,
                loadingBrowseTutorDataListApi: true,
                BrowseTutorDataListApiError: '',
            };
        case 'FETCH_BROWSE_TUTOR_DATA_SUCCESS':
            return {
                ...state,
                loadingBrowseTutorDataListApi: false,
                BrowseTutorDataListApiData: action.payload,
            };
        case 'FETCH_BROWSE_TUTOR_DATA_FAILURE':

            return {
                ...state,
                loadingBrowseTutorDataListApi: false,
                BrowseTutorDataListApiError: action.payload,
            };

        case 'FETCH_BROWSE_TUTOR_DETAIL_REQUEST':
            return {
                ...state,
                loadingBrowseTutorDetailListApi: true,
                BrowseTutorDetailListApiError: '',
            };
        case 'FETCH_BROWSE_TUTOR_DETAIL_SUCCESS':
            return {
                ...state,
                loadingBrowseTutorDetailListApi: false,
                BrowseTutorDetailListApiData: action.payload,
            };
        case 'FETCH_BROWSE_TUTOR_DETAIL_FAILURE':

            return {
                ...state,
                loadingBrowseTutorDetailListApi: false,
                BrowseTutorDetailListApiError: action.payload,
            };


        case 'FETCH_GROUP_COURSE_LIST_REQUEST':
            return {
                ...state,
                loadingGroupCourseListApi: true,
                GroupCourseListApiError: '',
            };
        case 'FETCH_GROUP_COURSE_LIST_SUCCESS':
            return {
                ...state,
                loadingGroupCourseListApi: false,
                GroupCourseListApiData: action.payload,
            };
        case 'FETCH_GROUP_COURSE_LIST_FAILURE':

            return {
                ...state,
                loadingGroupCourseListApi: false,
                GroupCourseListApiError: action.payload,
            };


        case 'FETCH_GROUP_COURSE_BATCH_LIST_REQUEST':
            return {
                ...state,
                loadingGroupCourseBatchListApi: true,
                GroupCourseBatchListApiError: '',
            };
        case 'FETCH_GROUP_COURSE_BATCH_LIST_SUCCESS':
            return {
                ...state,
                loadingGroupCourseBatchListApi: false,
                GroupCourseBatchListApiData: action.payload,
            };
        case 'FETCH_GROUP_COURSE_BATCH_LIST_FAILURE':

            return {
                ...state,
                loadingGroupCourseBatchListApi: false,
                GroupCourseBatchListApiError: action.payload,
            };


        case 'FETCH_GROUP_COURSE_BATCH_SESSION_LIST_REQUEST':
            return {
                ...state,
                loadingGroupCourseBatchSessionListApi: true,
                GroupCourseBatchSessionListApiError: '',
            };
        case 'FETCH_GROUP_COURSE_BATCH_SESSION_LIST_SUCCESS':
            return {
                ...state,
                loadingGroupCourseBatchSessionListApi: false,
                GroupCourseBatchSessionListApiData: action.payload,
            };
        case 'FETCH_GROUP_COURSE_BATCH_SESSION_LIST_FAILURE':

            return {
                ...state,
                loadingGroupCourseBatchSessionListApi: false,
                GroupCourseBatchSessionListApiError: action.payload,
            };


        case 'FETCH_CATEGORY_ON_TUTOR_LIST_REQUEST':
            return {
                ...state,
                loadingCategoryOnTutorListApi: true,
                CategoryOnTutorListApiError: '',
            };
        case 'FETCH_CATEGORY_ON_TUTOR_LIST_SUCCESS':
            return {
                ...state,
                loadingCategoryOnTutorListApi: false,
                CategoryOnTutorListApiData: action.payload,
            };
        case 'FETCH_CATEGORY_ON_TUTOR_LIST_FAILURE':

            return {
                ...state,
                loadingCategoryOnTutorListApi: false,
                CategoryOnTutorListApiError: action.payload,
            };


        case 'FETCH_SUB_CATEGORY_ON_TUTOR_LIST_REQUEST':
            return {
                ...state,
                loadingSubCategoryOnTutorListApi: true,
                SubCategoryOnTutorListApiError: '',
            };
        case 'FETCH_SUB_CATEGORY_ON_TUTOR_LIST_SUCCESS':
            return {
                ...state,
                loadingSubCategoryOnTutorListApi: false,
                SubCategoryOnTutorListApiData: action.payload,
            };
        case 'FETCH_SUB_CATEGORY_ON_TUTOR_LIST_FAILURE':

            return {
                ...state,
                loadingSubCategoryOnTutorListApi: false,
                SubCategoryOnTutorListApiError: action.payload,
            };


        case 'FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_REQUEST':
            return {
                ...state,
                loadingChildCategoryOnTutorListApi: true,
                ChildCategoryOnTutorListApiError: '',
            };
        case 'FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_SUCCESS':
            return {
                ...state,
                loadingChildCategoryOnTutorListApi: false,
                ChildCategoryOnTutorListApiData: action.payload,
            };
        case 'FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_FAILURE':

            return {
                ...state,
                loadingChildCategoryOnTutorListApi: false,
                ChildCategoryOnTutorListApiError: action.payload,
            };



        case 'FETCH_REQUEST_TUTOR_LIST_REQUEST':
            return {
                ...state,
                loadingStudentTutorRequestListApi: true,
                StudentTutorRequestListApiError: '',
            };
        case 'FETCH_REQUEST_TUTOR_LIST_SUCCESS':
            return {
                ...state,
                loadingStudentTutorRequestListApi: false,
                StudentTutorRequestListApiData: action.payload,
            };
        case 'FETCH_REQUEST_TUTOR_LIST_FAILURE':

            return {
                ...state,
                loadingStudentTutorRequestListApi: false,
                StudentTutorRequestListApiError: action.payload,
            };


        case 'FETCH_APPROVED_TUTOR_LIST_REQUEST':
            return {
                ...state,
                loadingStudentApprovedTutorListApi: true,
                StudentApprovedTutorListApiError: '',
            };
        case 'FETCH_APPROVED_TUTOR_LIST_SUCCESS':
            return {
                ...state,
                loadingStudentApprovedTutorListApi: false,
                StudentApprovedTutorListApiData: action.payload,
            };
        case 'FETCH_APPROVED_TUTOR_LIST_FAILURE':

            return {
                ...state,
                loadingStudentApprovedTutorListApi: false,
                StudentApprovedTutorListApiError: action.payload,
            };


        case 'FETCH_REQUEST_TUTOR_DETAIL_REQUEST':
            return {
                ...state,
                loadingStudentTutorRequestDetailsApi: true,
                StudentTutorRequestDetailsApiError: '',
            };
        case 'FETCH_REQUEST_TUTOR_DETAIL_SUCCESS':
            return {
                ...state,
                loadingStudentTutorRequestDetailsApi: false,
                StudentTutorRequestDetailsApiData: action.payload,
            };
        case 'FETCH_REQUEST_TUTOR_DETAIL_FAILURE':

            return {
                ...state,
                loadingStudentTutorRequestDetailsApi: false,
                StudentTutorRequestDetailsApiError: action.payload,
            };


        case 'FETCH_APPROVED_TUTOR_DETAIL_REQUEST':
            return {
                ...state,
                loadingStudentApprovedTutorDetailsApi: true,
                StudentApprovedTutorDetailsApiError: '',
            };
        case 'FETCH_APPROVED_TUTOR_DETAIL_SUCCESS':
            return {
                ...state,
                loadingStudentApprovedTutorDetailsApi: false,
                StudentApprovedTutorDetailsApiData: action.payload,
            };
        case 'FETCH_APPROVED_TUTOR_DETAIL_FAILURE':

            return {
                ...state,
                loadingStudentApprovedTutorDetailsApi: false,
                StudentApprovedTutorDetailsApiError: action.payload,
            };


        case 'FETCH_MY_BOOKINGS_LIST_REQUEST':
            return {
                ...state,
                loadingMyBookingsListApi: true,
                MyBookingsListApiError: '',
            };
        case 'FETCH_MY_BOOKINGS_LIST_SUCCESS':
            return {
                ...state,
                loadingMyBookingsListApi: false,
                MyBookingsListApiData: action.payload,
            };
        case 'FETCH_MY_BOOKINGS_LIST_FAILURE':

            return {
                ...state,
                loadingMyBookingsListApi: false,
                MyBookingsListApiError: action.payload,
            };

        case 'FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentStudyMaterialImageListApi: true,
                StudentStudyMaterialImageListApiError: '',
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentStudyMaterialImageListApi: false,
                StudentStudyMaterialImageListApiData: action.payload,
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentStudyMaterialImageListApi: false,
                StudentStudyMaterialImageListApiError: action.payload,
            };


        case 'FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentStudyMaterialPdfListApi: true,
                StudentStudyMaterialPdfListApiError: '',
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentStudyMaterialPdfListApi: false,
                StudentStudyMaterialPdfListApiData: action.payload,
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentStudyMaterialPdfListApi: false,
                StudentStudyMaterialPdfListApiError: action.payload,
            };

       // ===================== DOC LIST =====================

case "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_REQUEST":
    return {
        ...state,
        loadingStudentStudyMaterialDocListApi: true,
        StudentStudyMaterialDocListApiError: '',
    };

case "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_SUCCESS":
    return {
        ...state,
        loadingStudentStudyMaterialDocListApi: false,
        StudentStudyMaterialDocListApiData: action.payload,
    };

case "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_FAILURE":
    return {
        ...state,
        loadingStudentStudyMaterialDocListApi: false,
        StudentStudyMaterialDocListApiError: action.payload,
    };


// ===================== PPT LIST =====================

case "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_REQUEST":
    return {
        ...state,
        loadingStudentStudyMaterialPptListApi: true,
        StudentStudyMaterialPptListApiError: '',
    };

case "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_SUCCESS":
    return {
        ...state,
        loadingStudentStudyMaterialPptListApi: false,
        StudentStudyMaterialPptListApiData: action.payload,
    };

case "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_FAILURE":
    return {
        ...state,
        loadingStudentStudyMaterialPptListApi: false,
        StudentStudyMaterialPptListApiError: action.payload,
    };
        case 'FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentStudyMaterialVideoListApi: true,
                StudentStudyMaterialVideoListApiError: '',
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentStudyMaterialVideoListApi: false,
                StudentStudyMaterialVideoListApiData: action.payload,
            };
        case 'FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentStudyMaterialVideoListApi: false,
                StudentStudyMaterialVideoListApiError: action.payload,
            };


        case 'FETCH_STUDENT_QUERY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentQueriesListApi: true,
                StudentQueriesListApiError: '',
            };
        case 'FETCH_STUDENT_QUERY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentQueriesListApi: false,
                StudentQueriesListApiData: action.payload,
            };
        case 'FETCH_STUDENT_QUERY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentQueriesListApi: false,
                StudentQueriesListApiError: action.payload,
            };


        case 'FETCH_STUDENT_QUERIES_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingStudentQueriesDetailApi: true,
                StudentQueriesDetailApiError: '',
            };
        case 'FETCH_STUDENT_QUERIES_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentQueriesDetailApi: false,
                StudentQueriesDetailApiData: action.payload,
            };
        case 'FETCH_STUDENT_QUERIES_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingStudentQueriesDetailApi: false,
                StudentQueriesDetailApiError: action.payload,
            };


        case 'FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_REQUEST':
            return {
                ...state,
                loadingStudentMyTutorOneToOneListApi: true,
                StudentMyTutorOneToOneListApiError: '',
            };
        case 'FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentMyTutorOneToOneListApi: false,
                StudentMyTutorOneToOneListApiData: action.payload,
            };
        case 'FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_FAILURE':

            return {
                ...state,
                loadingStudentMyTutorOneToOneListApi: false,
                StudentMyTutorOneToOneListApiError: action.payload,
            };

        case 'FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_REQUEST':
            return {
                ...state,
                loadingStudentMyTutorGroupListApi: true,
                StudentMyTutorGroupListApiError: '',
            };
        case 'FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentMyTutorGroupListApi: false,
                StudentMyTutorGroupListApiData: action.payload,
            };
        case 'FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_FAILURE':

            return {
                ...state,
                loadingStudentMyTutorGroupListApi: false,
                StudentMyTutorGroupListApiError: action.payload,
            };


        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentOnlineLectureOneToOneTodayApi: true,
                StudentOnlineLectureOneToOneTodayApiError: '',
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentOnlineLectureOneToOneTodayApi: false,
                StudentOnlineLectureOneToOneTodayApiData: action.payload,
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentOnlineLectureOneToOneTodayApi: false,
                StudentOnlineLectureOneToOneTodayApiError: action.payload,
            };


        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentOnlineLectureGroupTodayApi: true,
                StudentOnlineLectureGroupTodayApiError: '',
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentOnlineLectureGroupTodayApi: false,
                StudentOnlineLectureGroupTodayApiData: action.payload,
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentOnlineLectureGroupTodayApi: false,
                StudentOnlineLectureGroupTodayApiError: action.payload,
            };


        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentOnlineLectureOneToOneMonthlyApi: true,
                StudentOnlineLectureOneToOneMonthlyApiError: '',
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentOnlineLectureOneToOneMonthlyApi: false,
                StudentOnlineLectureOneToOneMonthlyApiData: action.payload,
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentOnlineLectureOneToOneMonthlyApi: false,
                StudentOnlineLectureOneToOneMonthlyApiError: action.payload,
            };



        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentOnlineLectureGroupMonthlyApi: true,
                StudentOnlineLectureGroupMonthlyApiError: '',
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentOnlineLectureGroupMonthlyApi: false,
                StudentOnlineLectureGroupMonthlyApiData: action.payload,
            };
        case 'FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentOnlineLectureGroupMonthlyApi: false,
                StudentOnlineLectureGroupMonthlyApiError: action.payload,
            };


        case 'FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingStudentBookedTutorDetailApi: true,
                StudentBookedTutorDetailApiError: '',
            };
        case 'FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentBookedTutorDetailApi: false,
                StudentBookedTutorDetailApiData: action.payload,
            };
        case 'FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingStudentBookedTutorDetailApi: false,
                StudentBookedTutorDetailApiError: action.payload,
            };


        case 'FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentCompletedAssListApi: true,
                StudentCompletedAssListApiError: '',
            };
        case 'FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentCompletedAssListApi: false,
                StudentCompletedAssListApiData: action.payload,
            };
        case 'FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentCompletedAssListApi: false,
                StudentCompletedAssListApiError: action.payload,
            };


        case 'FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentUpcomingAssListApi: true,
                StudentUpcomingAssListApiError: '',
            };
        case 'FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentUpcomingAssListApi: false,
                StudentUpcomingAssListApiData: action.payload,
            };
        case 'FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentUpcomingAssListApi: false,
                StudentUpcomingAssListApiError: action.payload,
            };


        case 'FETCH_STUDENT_NOTIFICATION_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudenNotificationListApi: true,
                StudenNotificationListApiError: '',
            };
        case 'FETCH_STUDENT_NOTIFICATION_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudenNotificationListApi: false,
                StudenNotificationListApiData: action.payload,
            };
        case 'FETCH_STUDENT_NOTIFICATION_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudenNotificationListApi: false,
                StudenNotificationListApiError: action.payload,
            };


        case 'FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentSmallNotificationListApi: true,
                StudentSmallNotificationListApiError: '',
            };
        case 'FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentSmallNotificationListApi: false,
                StudentSmallNotificationListApiData: action.payload,
            };
        case 'FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentSmallNotificationListApi: false,
                StudentSmallNotificationListApiError: action.payload,
            };


        case 'FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingStudentBookedCourseListApi: true,
                StudentBookedCourseListApiError: '',
            };
        case 'FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingStudentBookedCourseListApi: false,
                StudentBookedCourseListApiData: action.payload,
            };
        case 'FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingStudentBookedCourseListApi: false,
                StudentBookedCourseListApiError: action.payload,
            };



        default:
            return state;
    }
}
export default StudentReducer;